var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLaos(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53039)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4125 9.46245C27.8245 4.11051 22.3435 0.418945 16.0001 0.418945C9.65677 0.418945 4.17577 4.11051 1.58777 9.46245L16.0001 10.8538L30.4125 9.46245Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.58777 23.3755C4.17577 28.7274 9.65677 32.419 16.0001 32.419C22.3435 32.419 27.8245 28.7274 30.4125 23.3755L16.0001 21.9842L1.58777 23.3755Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4124 9.46217H1.58763C0.5705 11.5656 0 13.9255 0 16.4187C0 18.9119 0.5705 21.2717 1.58763 23.3752H30.4123C31.4296 21.2717 32 18.9119 32 16.4187C32 13.9255 31.4296 11.5656 30.4124 9.46217V9.46217Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.9841C19.0736 21.9841 21.5652 19.4925 21.5652 16.4189C21.5652 13.3453 19.0736 10.8537 16 10.8537C12.9264 10.8537 10.4348 13.3453 10.4348 16.4189C10.4348 19.4925 12.9264 21.9841 16 21.9841Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53039"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.418945)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaos);
export default __webpack_public_path__ + "static/media/laos.74288e2d.svg";
export { ForwardRef as ReactComponent };